<script>
  import { writable } from "svelte/store";
  import { navigate } from "../router";
  import { getUser } from "../user.js";
  import { onMount } from "svelte";
  import { send_bulk_email, load, count } from "../mailing.js";
  import {
    Background,
    Font,
  } from "../component/modifier";
  import { HStack, VStack, Spacer } from "../component/layout";
  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Copyright from "../component/Copyright.svelte";
  import { Button, Label, Checkbox } from "../component/widget";

  export let wedding_guid;

  export let bapteme = true

  let guests = writable([]);
  let guests_checked = {};
  let current = null;
  let all = false;

  const toogle = (checked) => {
    console.log($guests);
    $guests.forEach((g) => {
      if (g.email) {
        guests_checked[g.id] = checked;
      }
    });
  };

  $: {
    toogle(all);
  }

  const refresh = (id) => {
    load(wedding_guid)
      .then((r) => {
        all = false;
        let mails = new Map();

        console.log(r);

        r.forEach((e) => {
          let g = mails.get(e.id);
          if (g === undefined) {
            g = {
              id: e.id,
              wedding_id: e.wedding_id,
              invitation_id: e.invitation_id,
              name: e.name,
              lastname: e.lastname,
              firstname: e.firstname,
              email: e.email,
              code: e.code,
              is_attending: e.is_attending,
              STD: {},
              FP: {},
              FPB: {},
              R: {},
            };
            mails.set(g.id, g);
            guests_checked[g.id] = false;
          }
          if (e.type) {
            let m = g[e.type];
            m.id = e.send_id;
            m.error = e.error;
            m.mail_id = e.mail_id;
            m.status = e.status;
            m.read = e.read;
          }
        });

        guests.set(Array.from(mails.values()));
      })
      .catch((e) => {
        console.log(e);
      });
  };

  let userRequest;

  onMount(() => {
    console.log("Mailing on mount");
    userRequest = getUser();

    const unsubscribe = userRequest.subscribe((promise) => {
      promise
        .then((u) => {
          refresh();
        })
        .catch((e) => {
          navigate("/");
        });
    });

    return () => {
      console.log("Mailing destroy");
      unsubscribe();
    };
  });

  const extractCount = (mailings, type) => {
    let m = mailings.find((e) => e.type == type);
    return m ? m.count : "0";
  };

  const send_std = async () => {
    await send_bulk_email(
      wedding_guid,
      "STD",
      1,
      $guests.filter((g) => guests_checked[g.id])
    );
    refresh(wedding_guid);
  };

  const send_fp = async () => {
    await send_bulk_email(
      wedding_guid,
      bapteme ? "FPB" : "FP",
      1,
      $guests.filter((g) => guests_checked[g.id])
    );
    refresh(wedding_guid);
  };

  const send_r = async () => {
    await send_bulk_email(
      wedding_guid,
      "R",
      1,
      $guests.filter((g) => guests_checked[g.id])
    );
    refresh(wedding_guid);
  };
</script>

<main>
  <CookieConsent />
  <Header>
    <div slot="left">
      <Button action={() => navigate(`#/dashboard/${wedding_guid}`)}>
        <Label text="Dashboard" icon="tachometer-alt" borderLeft h="48px" />
      </Button>
    </div>
  </Header>
  <Background color="white">
    <HStack grow alignment="stretch">
      <article>
        <HStack>
          <Spacer />
          <Font name="Cinzel" size="1.5em">RSVP</Font>
          <Spacer />
        </HStack>
        <VStack>
          {#await count(wedding_guid) then mailings}
            <HStack>
              <Button action={send_std}>
                <Label text="Envoyer Save The Date" icon="envelope-open-text" />
              </Button>
              <div class="label">
                <Label
                  text={extractCount(mailings, "STD") + " déjà envoyé(s)"}
                  icon="share-square" />
              </div>
            </HStack>
            <HStack>
              <Button action={send_fp}>
                <Label text="Envoyer Faire Part" icon="envelope-open-text" />
              </Button>
              <div class="label">
                <Label
                  text={extractCount(mailings, bapteme ? "FP" : "FPB") + " déjà envoyé(s)"}
                  icon="share-square" />
              </div>
            </HStack>
            <HStack>
              <Button action={send_r}>
                <Label text="Envoyer Remerciement Cagnotte" icon="envelope-open-text" />
              </Button>
              <div class="label">
                <Label text={extractCount(mailings, "R") + " déjà envoyé(s)"} icon="share-square" />
              </div>
            </HStack>
          {/await}
        </VStack>
        <table>
          <thead>
            <th>
              <Checkbox id="Tous" bind:value={all} bind:current />
            </th>
            <th>Famille</th>
            <th>Nom</th>
            <th>Email</th>
            <th>Code invité</th>
            <th>Save The Date</th>
            <th>Faire Part</th>
            <th>Remerciement</th>
          </thead>
          <tbody>
            {#each $guests as g, i (g.id)}
              <tr>
                <td>
                  {#if g.email}
                    <Checkbox id={g.id} bind:value={guests_checked[g.id]} bind:current />
                  {/if}
                </td>
                <td>{g.name}</td>
                <td>{g.lastname + " " + g.firstname}</td>
                <td>{g.email}</td>
                <td>{g.code}</td>
                <td>
                  {#if g.STD.status == "OK"}
                    <Label text="OK" icon="check" />
                  {/if}
                  {#if g.STD.status == "PENDING"}
                    <Label
                      text="En attente"
                      icon="hourglass-start"
                      color="var(--secondary-light-color)" />
                  {/if}
                  {#if g.STD.status == "ERROR"}
                    <Label
                      text="En erreur"
                      icon="times-circle"
                      iconColor="var(--error-color)"
                      color="var(--error-color)"
                      tooltip={g.STD.error} />
                  {/if}
                  {#if g.STD.read === "1"}
                    <span class="read">Lu</span>
                  {/if}
                  {#if g.STD.mail_id}
                    <a
                      href={`https://mariage-parfait.com/mailing/?id=${g.STD.mail_id}`}
                      target="_blank"
                      alt="Save The Date"><i class="fas fa-external-link-alt" /></a>
                  {/if}
                </td>
                <td>
                  {#if bapteme}
                    {#if g.FPB.status == "OK"}
                      <Label text="OK" icon="check" />
                    {/if}
                    {#if g.FPB.status == "PENDING"}
                      <Label
                        text="En attente"
                        icon="hourglass-start"
                        color="var(--secondary-light-color)" />
                    {/if}
                    {#if g.FPB.status == "ERROR"}
                      <Label text="En erreur" icon="times-circle" color="var(--error-color)" />
                    {/if}
                    {#if g.FPB.read === "1"}
                      <span class="read">Lu</span>
                    {/if}
                    {#if g.FPB.mail_id}
                      <a
                        href={`https://mariage-parfait.com/mailing/?id=${g.FPB.mail_id}`}
                        target="_blank"
                        alt="Faire-Part"><i class="fas fa-external-link-alt" /></a>
                    {/if}
                  {:else}
                    {#if g.FP.status == "OK"}
                      <Label text="OK" icon="check" />
                    {/if}
                    {#if g.FP.status == "PENDING"}
                      <Label
                        text="En attente"
                        icon="hourglass-start"
                        color="var(--secondary-light-color)" />
                    {/if}
                    {#if g.FP.status == "ERROR"}
                      <Label text="En erreur" icon="times-circle" color="var(--error-color)" />
                    {/if}
                    {#if g.FP.read === "1"}
                      <span class="read">Lu</span>
                    {/if}
                    {#if g.FP.mail_id}
                      <a
                        href={`https://mariage-parfait.com/mailing/?id=${g.FP.mail_id}`}
                        target="_blank"
                        alt="Faire-Part"><i class="fas fa-external-link-alt" /></a>
                    {/if}
                  {/if}
                </td>
                <td>
                  {#if g.R.status == "OK"}
                    <Label text="OK" icon="check" />
                  {/if}
                  {#if g.R.status == "PENDING"}
                    <Label
                      text="En attente"
                      icon="hourglass-start"
                      color="var(--secondary-light-color)" />
                  {/if}
                  {#if g.R.status == "ERROR"}
                    <Label text="En erreur" icon="times-circle" color="var(--error-color)" />
                  {/if}
                  {#if g.R.read === "1"}
                    <span class="read">Lu</span>
                  {/if}
                  {#if g.R.mail_id}
                    <a
                      href={`https://mariage-parfait.com/mailing/?id=${g.R.mail_id}`}
                      target="_blank"
                      alt="Faire-Part"><i class="fas fa-external-link-alt" /></a>
                  {/if}
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </article>
    </HStack>
  </Background>

  <Copyright company="KiwisApp" />
</main>

<style>
  article {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: calc(100% - 100px);
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    border: 1px solid #ddd;
    padding: 8px;
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: var(--primary-light-color);
    color: white;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  span.read {
    font-size: small;
    color: var(--primary-light-color);
  }

  div.label {
    line-height: 1em;
    border-radius: 15px;
    background-color: var(--secondary-light-color);
    padding: 0.5em;
    margin-bottom: 5px;
    font-size: small;
  }
</style>
